import controller from './landing.controller';
import templateT1 from './templates/landing-t1.view.html';
import templateAD from './templates/landing-adaptative.html';

let LandingComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];


function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  }else{
    return templateT1
  }
}

export default LandingComponent;



/** WEBPACK FOOTER **
 ** ./www/components/landing/landing.componet.js
 **/